import React from 'react'

import Grid from '../../../../components/pdf/Grid'
import Image from '../../../../components/pdf/Image'

const Header = () => {
  return (
    <Grid justify="left" align="left">
      <Image src="/pdfs/lopesdefaria/header-bg.jpg" ignoreFixedSize />
    </Grid>
  )
}

export default Header
